import React from 'react'
import style from '../scss/components/Tooltip.module.scss'
import { Fade } from "react-awesome-reveal"
import kristoSmallImg from '../assets/kristo-olli-small.png'
import kristoSmallImg2x from '../assets/kristo-olli-small@2x.png'
import kristoSmallImg3x from '../assets/kristo-olli-small@3x.png'

const Tooltip = () => {
    return (
        <div className={style.Container}>
            <Fade direction={'up'} triggerOnce={true}>
                <div className={style.Main}>
                    <div className={style.ImageWrapper}>
                        <img src={kristoSmallImg}
                             srcSet={`${kristoSmallImg2x} 2x, ${kristoSmallImg3x} 3x`}
                             alt={''}
                        />
                    </div>
                    <div className={style.TextWrapper}>
                        <h4>SalonSecrets</h4>
                        <h2>Sinu salongi uus tase.
                            Kas oled parimate salongi <strong>müügi- ja turundusnippide</strong> avastamiseks valmis?</h2>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default Tooltip
